<template>
  <v-app>
    <blog-header :navColor="navColor" :color="color" @changeColor="changeColor"></blog-header>
    <v-main>
       <blogHome app :color="navColor"></blogHome>
      <div class="blogger-content">
        <router-view  :key="key"></router-view>
      </div>
    </v-main>
    
    <v-footer app :color="navColor" dark padless>
      <blogFooter :color="navColor" :height="'27px'"/>
    </v-footer>

  </v-app>
</template>

<script>
import CONFIG from '@/config/config.js';
import blogHome from '@/views/blogHome.vue';
import blogHeader from '@/views/blogHeader.vue';
import blogFooter from '@/views/blogFooter.vue';
import projectList from '@/components/projectList'

import IDEA from "@/assets/imgs/nav/idea.png"
import EMOJ from "@/assets/imgs/nav/emoj.png"
import HOMEPNG from "@/assets/imgs/nav/home.png"
import SEARCH from "@/assets/imgs/nav/search.png"
import NOTE from "@/assets/imgs/nav/notebook.png"
import SUBJECT from "@/assets/imgs/nav/subject.png"
import PALETTE from "@/assets/imgs/nav/palette.png"
import COLLECTION from "@/assets/imgs/nav/collection.png"

export default {
  name: 'App',
  components: {
    blogHome,
    blogFooter,
    blogHeader,
    projectList
  },
  data () {
    return {
      navColor:"#4CAF50",
      colorList:[
        '#4CAF50',
        '#03A9F4',
        '#FB8C00',
        '#1DE9B6',
        '#B388FF',
        '#69F0AE',
        '#121212',
      ],
      colorIndex:1,
      color:"#03A9F4",
    }
  },
  computed: {
    key() {
      return this.$route.name !== undefined? this.$route.name +new Date(): this.$route +new Date()
    }
  },
  methods:{
    changeColor(){
      let _this = this;
      _this.colorIndex ++;
      if (_this.colorIndex >=7){
        _this.colorIndex = 0;
        _this.color = _this.colorList[0];
        _this.navColor = _this.colorList[6];
      }else{
        _this.color = _this.colorList[_this.colorIndex];
        _this.navColor = _this.colorList[_this.colorIndex - 1];
      }
    }
  },
  mounted() {}
}
</script>

<style lang="stylus" scoped>
.blogger-content
  position relative
  top  0
  bottom 0
  border 0
  right 0
  left 0
  width 100%
  height:100%
.blogger-footer
  position relative
  bottom 0
  top 0
  left  0
  right  0
</style>
